import latest from "@/helper/parser/latest";
import base from "@/helper/parser/base";
import debug from "@/helper/debug";

export default {
    parser: [
        {parser: base, version: '8.0.6'},
        {parser: latest, version: 'latest'},
    ],

    parse(content) {
        return new Promise((resolve, reject) => {
            try {
                if (typeof content === 'string') content = JSON.parse(content)

                let id = content['file_hash'].join('-')
                let hash = content['file_hash']
                let version = /\((.+)\)/.exec(content['version'] ?? content['_version'])[1]

                if (version < '7.0.0') return reject('Unsupported version')
                if (!id || !hash || !version) return reject('Invalid log file')

                let parser = this.parser.find(p => p.version >= version).parser
                debug.info('Parser: ' + parser.version)

                resolve({
                    id, hash, version, content,
                    ...parser.parse(content),
                })
            } catch(e) {
                return reject('Invalid log file')
            }
        })
    },
}